import React from "react";
import SupportingText from "../SupportingText";
import { ArrowRight } from "../Icons";

export default function AttributeSelectionRow({
  attribute,
  currentRefinement
}) {
  const isRefined = currentRefinement && currentRefinement.length > 0;
  return (
    <div className="w-full relative flex items-center justify-between py-4">
      <SupportingText textColor="black" textSize="base">
        {attribute}
      </SupportingText>
      {isRefined ? (
        <div
          style={{
            borderRadius: "50%",
            width: "28px",
            height: "28px",
            right: "40px"
          }}
          className="bg-teal absolute flex items-center justify-center"
        >
          <SupportingText textColor="white" textSize="base">
            {currentRefinement.length}
          </SupportingText>
        </div>
      ) : null}
      <ArrowRight
        stroke={!isRefined ? "#EF5753" : "#4DC0B5"}
        width="40px"
        height="20px"
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/AttributeSelectionRow/AttributeSelectionRow.js